import React, { useContext, useState } from 'react';
import WithAuth from '../utils/WithAuth';
import { useNavigate } from 'react-router-dom';
import "../App.css"
import { Button, IconButton, TextField } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import {AuthContext} from '../context/AuthContext';

function Home() {
    let navigate=useNavigate()
const [meeingcode,setmeetingcode]=useState("")

const {addToUserHistory}=useContext(AuthContext)
let handleJoinCall=async()=>{
    await addToUserHistory(meeingcode)
    navigate(`/${meeingcode}`)
}
    return ( 
        <div>
            <div className="navBar">
                <div style={{display:"flex",alignItems:"center"}}>
                    <h2>Video call</h2>
                </div>
                <div style={{display:"flex",alignItems:"center"}}>
                   <IconButton onClick={
                    ()=>{
                        navigate("/history")
                    }
                   }>
                    <RestoreIcon/>
                    </IconButton>
                    
                    <p>History</p>

                    <Button onClick={()=>{
                        localStorage.removeItem("token")
                        navigate("/auth")
                    }}>
                        Logout
                    </Button>
                  
                </div>
            </div>
            <div className="meetContainer">
                <div className="leftpanel">
                    <div>
                        <h2 style={{marginBottom:"20px"}}>Providing Quality Video Call Just Like Education</h2>
                        <div style={{display:"flex",gap:"10px"}}>
                            <TextField onChange={e=>setmeetingcode(e.target.value)} id="outlined" label="Meeting code"></TextField>
                                <Button onClick={handleJoinCall} variant='contained'>Join</Button>
                        </div>
                    </div>
                </div>
                <div className="rightpanel">
                    <img src="public/videocall (2).png" alt="" />
                </div>
            </div>
        </div>
     );
}

export default WithAuth(Home);